import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from './custom-snackbar.component';
import { SnackBarConfig } from './snack-bar-config';
import { SparrowSnackbarComponent } from './sparrow-snackbar.component';
import { extractApiValidationErrorMessage } from '../../../core/api-error.utils';
import { defaultErrorMessage } from '../../../core/localize.utils';

@Injectable({ providedIn: 'root' })
export class SnackBarService {
  private defaultConfig: SnackBarConfig = {
    duration: 2000,
    politeness: 'polite',
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
  };

  constructor(private snackBar: MatSnackBar) {}

  showSuccessMessage(message: string, config?: SnackBarConfig) {
    this.openSnackBar(message, 'success', config);
  }

  showInfoMessage(message: string, config?: SnackBarConfig) {
    this.openSnackBar(message, 'info', config);
  }

  showErrorMessage(message: string, config?: SnackBarConfig) {
    this.openSnackBar(message, 'alert', config);
  }

  showDefaultErrorMessage(config?: SnackBarConfig) {
    this.openSnackBar(defaultErrorMessage, 'alert', config);
  }

  // Shows the backend validation message for 400 responses, the generic message otherwise.
  showApiErrorMessage(err: unknown, config?: SnackBarConfig) {
    const message = extractApiValidationErrorMessage(err);
    if (message) {
      this.showErrorMessage(message, config);
    } else {
      this.showDefaultErrorMessage(config);
    }
  }

  showSparrowSuccessMsg(message: string, color: string, config?: SnackBarConfig) {
    this.openSparrowSnackBar(message, 'success', color, config);
  }

  private openSnackBar(message: string, className: string, config: SnackBarConfig) {
    const finalConfig = { ...this.defaultConfig, ...config } as SnackBarConfig;
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      duration: finalConfig.duration,
      data: { title: message, icon: finalConfig.icon, extraClass: className },
      panelClass: ['custom-snackbar', className],
      verticalPosition: finalConfig.verticalPosition,
      horizontalPosition: finalConfig.horizontalPosition,
    });
  }

  private openSparrowSnackBar(message: string, className: string, color: string, config: SnackBarConfig) {
    const finalConfig = { ...this.defaultConfig, ...config } as SnackBarConfig;
    this.snackBar.openFromComponent(SparrowSnackbarComponent, {
      duration: finalConfig.duration,
      data: { title: message, icon: finalConfig.icon, extraClass: className, textColor: color },
      panelClass: ['sparrow-snackbar', className],
      verticalPosition: finalConfig.verticalPosition,
      horizontalPosition: finalConfig.horizontalPosition,
    });
  }
}
